
import { Budget } from '@/models/Budget';
import { Helper } from '@/models/HelperClasses';
import { SizeAndPrice } from '@/models/VirtualMachine';
import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class SizeAndPriceTable extends Vue {
    @Prop() private items!: SizeAndPrice[];
    @Prop({required: false}) private currentWorkspaceCostPerDay!: number;
    @Prop({required: false}) private budget!: Budget;

    @Prop({required: false}) private currentSize!: string;
    @Prop({required: false}) private currentMachineIsDeallocated!: boolean;
    @Prop({required: true}) private id: string;


    get filteredItems(): SizeAndPrice[] {
        if(this.currentSize){
            return this.items.filter(size => {return size.technicalName !== this.currentSize && size.visible}).sort();
        }
        return this.items.filter(size => {return size.visible}).sort();
    }

    futureWorkspaceCostPerDay(vmPricePerHour: number): number {
        if(this.currentSize){ //replace current size by future size
            var currentSize: SizeAndPrice = this.items.find(size => {return size.technicalName.toLowerCase() === this.currentSize.toLowerCase()});
            var currentMachineSubtraction = this.currentMachineIsDeallocated ? 0 : currentSize.pricePerHour*24;
            var futureCostPerDay = this.currentWorkspaceCostPerDay - currentMachineSubtraction + vmPricePerHour*24; //Note: 0.6 is skipped because we are replacing one machine by another, so the 0.6 falls away
            return futureCostPerDay;
        }
        return this.currentWorkspaceCostPerDay + vmPricePerHour*24 + 0.6; //0.6 is base cost like disk
    }

    futureDaysOfBudgetRemaining(vmPricePerHour: number): number {
        if(!this.budget){
            return;
        }
        var budgetleft = this.budget.amount * 0.95 - this.budget.currentSpend;
        var futureWorkspaceCostPerDay =  this.futureWorkspaceCostPerDay(vmPricePerHour);
        var daysRemaining = budgetleft /futureWorkspaceCostPerDay;
        return daysRemaining < 0 ? 0 : daysRemaining;
    }

    public sizeTablefields = [
        {
            key: "displayName",
            label: "Type",
            sortable: true,
        },
        {
            key: "numberOfCores",
            label: "vCPUs",
            sortable: true,
        },
        {
            key: "memoryInMB",
            label: "RAM (MB)",
            sortable: true,
        },
        {
            key: "pricePerHour",
            label: "Price per day",
            sortable: true
        }
    ];

    formatMoney(money: number){
        return Helper.formatMoney(money);
    }

    async onRowSelected(items: SizeAndPrice[]) {
        if(items.length === 0) return;
        var selectedSize = items[0];
        var futureDaysOfBudgetRemaining = this.futureDaysOfBudgetRemaining(selectedSize.pricePerHour);
        this.$emit("onRowSelected", selectedSize, futureDaysOfBudgetRemaining);
    }

    async onRowClick(item: SizeAndPrice) {
        var futureDaysOfBudgetRemaining = this.futureDaysOfBudgetRemaining(item.pricePerHour);
        this.$emit("onRowClick", item, futureDaysOfBudgetRemaining);
    }

}
